import React from 'react';
import { renderDonation } from './shared/renderers';

/**
 * DonationBlock — rendu PARTAGÉ avec l'éditeur intranet (shared/renderers).
 * Section virement (IBAN/BIC + copie) et don en ligne (Donorbox).
 */
export default function DonationBlock({ props = {}, theme }) {
  return renderDonation(props, theme);
}
